export default __webpack_public_path__ + "static/media/bolt-solid.f792c283.svg";